import {
  Templates,
  type LayoutQueryFilter,
} from "@package/ui-gql/index-data-access";
import { type WritableDraft } from "immer";
import { sortBy, uniq } from "lodash";
import { useMemo, useState } from "react";
import { TEMPLATE_TO_DISPLAY } from "../../constants/constants";
import { useItemGridFilterContext } from "../ItemGridFilter/context-item-grid-filter";
import {
  ItemGridFilterDataList,
  type FilterValueEntry,
} from "../ItemGridFilter/ItemGridFilterDataList";

type SupportedFilter = LayoutQueryFilter | null | undefined;

export function ItemGridFilterTemplateType() {
  const [query, setQuery] = useState<string>("");

  const { filter, updateFilterState } = useItemGridFilterContext();

  const filterWithTemplateType: SupportedFilter = filter;
  const items = useMemo<FilterValueEntry[]>(() => {
    const values: FilterValueEntry[] =
      Object.values(Templates)
        .map((template) => {
          const id = template;
          const name = TEMPLATE_TO_DISPLAY[template];
          const checked =
            filterWithTemplateType?.template?.includes(id) ?? false;
          return {
            id,
            name,
            checked,
          };
        })
        .filter((entry) =>
          entry.name.toLowerCase().includes(query.toLowerCase()),
        ) ?? [];

    return sortBy(values, (entry) => entry.name);
  }, [filterWithTemplateType?.template, query]);

  return (
    <ItemGridFilterDataList
      items={items}
      property="template"
      text="Template"
      onQueryValueChanged={setQuery}
      onRequestFilterReset={() =>
        updateFilterState((draft: WritableDraft<SupportedFilter>) => {
          if (draft) {
            delete draft.template;
          }
        })
      }
      onRequestFilterUpdate={(id, include) =>
        updateFilterState((draft: WritableDraft<SupportedFilter>) => {
          if (draft) {
            if (include) {
              draft.template = uniq([
                ...(draft.template ?? []),
                id as Templates,
              ]);
            } else if (draft.template?.length) {
              draft.template = draft.template.filter(
                (template) => template !== id,
              );
            }

            if (!draft.template?.length) {
              delete draft.template;
            }
          }
        })
      }
      onSelectAllChanged={(checked) => {
        updateFilterState((draft: WritableDraft<SupportedFilter>) => {
          if (draft) {
            if (checked) {
              draft.template = items.map((item) => item.id as Templates);
            } else {
              delete draft.template;
            }
          }
        });
      }}
    />
  );
}
